module.exports = __webpack_public_path__ + "static/media/w (1).da4b303b.jpg";